import React, { useEffect, useRef, useState } from 'react';

export function useInView(threshold = 0.2) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setInView(true); },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

export function Reveal({ children, className = '', delay = 0 }) {
  const [ref, inView] = useInView(0.15);
  return (
    <div ref={ref} className={`reveal ${inView ? 'in' : ''} ${className}`} style={{ transitionDelay: `${delay}ms` }}>
      {children}
    </div>
  );
}

export default function Section({ id, eyebrow, title, lead, children, className = '' }) {
  return (
    <section id={id} className={`relative py-28 lg:py-36 ${className}`}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        {(eyebrow || title || lead) && (
          <div className="mb-16 lg:mb-20 grid lg:grid-cols-12 gap-8 items-end">
            <div className="lg:col-span-7">
              {eyebrow && (
                <Reveal>
                  <div className="pin-num mb-5">{eyebrow}</div>
                </Reveal>
              )}
              {title && (
                <Reveal delay={80}>
                  <h2 className="font-display text-white text-[40px] md:text-[56px] lg:text-[72px] leading-[1] tracking-[-0.04em]">
                    {title}
                  </h2>
                </Reveal>
              )}
            </div>
            {lead && (
              <div className="lg:col-span-5 lg:pl-10">
                <Reveal delay={140}>
                  <p className="text-white/65 text-[15.5px] leading-[1.7] max-w-[440px]">{lead}</p>
                </Reveal>
              </div>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
